import React, { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import './interviewmanagement.css';
// no location/context needed here — child pages handle context themselves

import ArrowBack from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserTypeContext } from "../../AppRoute";
import JDUpload from '../../components/jobdescupload/jdupload';
import ManageJd from '../../components/managejobdesc/managejd';




const InterviewManagement = () => {
    const location = useLocation();
    const [tabValue, setTabValue] = useState(location?.state?.tabValue || 0);
    const { userType, userRecords } = useContext(UserTypeContext);
      const userRecruitmentpartnerId =
        userType === "Admin"
          ? location?.state?.recruitmentPartnerId
          : userRecords?.recruitmentpartnerId;
      const idContextTest =
        userType === "Admin" ? location?.state?.id : userRecords?.id;
      const userRole =
        userType === "Admin"
          ? location?.state?.userRole
          : userRecords?.role?.roleName;
      const userRecordData =
        userType === "Admin" ? location?.state?.userRecords : userRecords;
     const history = useNavigate();
    const gotoDashBoard = () => {
    history("/dashboard",
      {
        state: {
          userType: userType,
          recruitmentPartnerId: userRecruitmentpartnerId,
          id: idContextTest,
          userRecords: userRecordData,
          roleName: userRole,
        },
      });
  };


    return (
        <div className="interview_management_container">
            <div className="topContainer_interview_management">
                <div className='mainDiv_interview_management'>
                    
                    <div className="reportHeader_interview_management">
                        <Tooltip title="Go Back to Dashboard" placement="bottom">
                            <div className="goBackButton_interview_management" onClick={(e) => gotoDashBoard()}>
                                <ArrowBack sx={{ fontSize: 20 }} />
                                
                            </div>
                        </Tooltip>
                        <div className="reportTitle_interview_management">Interview Management</div>
                    </div>

                    <Box className="interview_management_tabs_box" sx={{ mb: 2 }}>
                        <div className="tabsMainContainer_interview_management">
                            <div className="tabsContainer_interview_management">
                                <div
                                    className={tabValue === 0 ? 'tabs_interview_management tabs_interview_management_selected' : 'tabs_interview_management'}
                                    onClick={() => setTabValue(0)}
                                >
                                    Create Interview
                                </div>
                                <div
                                    className={tabValue === 1 ? 'tabs_interview_management tabs_interview_management_selected' : 'tabs_interview_management'}
                                    onClick={() => setTabValue(1)}
                                >
                                    Interview Dashboard
                                </div>
                            </div>
                        </div>
                    </Box>


                    <div className="gridContainer_interview_management">
                        <div className="kendoContainer_interview_management">
                            {tabValue === 0 && <JDUpload />}
                            {tabValue === 1 && <ManageJd />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InterviewManagement;